import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { identityVerificationValidateSearchSchema } from '../../common/identityVerification/helpers/identityVerificationValidateSearchSchema';
import { serviceSettingsRoute } from '../route';

export const serviceIdentityVerificationRoute = createRoute({
	getParentRoute: () => serviceSettingsRoute,
	path: '/identity-verification',
	component: lazyRouteComponent(
		() => import('./IdentityVerificationPage'),
		'IdentityVerificationPage',
	),
	validateSearch: identityVerificationValidateSearchSchema,
});
